import axios_nomura from './axios-nomura.services';

export const addFavoriteFund = async (data) => {
  return await axios_nomura.post(`api/v1/funds/favorite`, JSON.stringify(data.fundId));
};

export const deleteFavoriteFund = async (data) => {
  return await axios_nomura.post(`api/v1/funds/favorite/delete`, JSON.stringify(data.fundId));
};

export const putFavoriteFunds = async (data) => {
  return await axios_nomura.put(`api/v1/funds/favorite`, data.fundIds);
};

export const fetchFavoriteFundsByAccount = async () => {
  return await axios_nomura.get(`api/v1/funds/favorites`);
};
